export default function(x) {
  return x === null ? NaN : +x;
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-array/src/number.js
// module id = 12
// module chunks = 0